import React from 'react';
import { Alert, Card } from 'antd';
import ClubMondaySelect from './StudentClubForm/ClubMondaySelect';
import ClubTuesdaySelect from './StudentClubForm/ClubTuesdaySelect';
import ClubWednesdaySelect from './StudentClubForm/ClubWednesdaySelect';
import ClubThursdaySelect from './StudentClubForm/ClubThursdaySelect';
import ClubFriDaySelect from './StudentClubForm/ClubFridaySelect';


const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
const clubReminderMessage = '貼心提醒：為讓孩子們能從容適應學習節奏、兼顧學習品質，每週社團活動請以三項為上限!! 至少 2 天必須選擇「安親」或「自接」，感謝您的支持與配合!';
const StudnetClub = ({ validationError, ruleStatus }) => {
    const showLiveHint = ruleStatus && ruleStatus.hasAnySelection;

    return (
        <Card title="社團資訊">
            <ClubMondaySelect />
            <ClubTuesdaySelect />
            <ClubWednesdaySelect />
            <ClubThursdaySelect />
            <ClubFriDaySelect />
            {showLiveHint && !validationError && (
                <Alert
                    type={ruleStatus.isValid ? "success" : "error"}
                    showIcon
                    style={{ marginBottom: '12px' }}
                    message={clubReminderMessage}
                />
            )}
            {validationError && (
                <Alert
                    type="error"
                    showIcon
                    style={{ marginBottom: '12px' }}
                    message={validationError}
                />
            )}
            <h3>
                社團資料請參考<a href="http://www.fhbes.tc.edu.tw/content/社團資訊club-information" target="_new">學校網站</a>
            </h3>
        </Card>
    )
}
export default StudnetClub



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/StudnetClub.jsx